// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__RGYry","subheader":"ReorderModal_subheader__BbQGs","listWrap":"ReorderModal_listWrap__1jFdz"};